import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  loaded: false,
})

const { Types, Creators } = createActions({
  setDelivererOrders: ['delivererOrders'],
  getDelivererOrders: ['delivererKeys', 'startFrom', 'endAt'],
})

export const getDelivererOrdersReducer = state => state.set('loaded', false)

export const setDelivererOrdersReducer = (state, { delivererOrders }) =>
  state.set('data', delivererOrders).set('loaded', true)

export const delivererOrderReducer = createReducer(INITIAL_STATE, {
  [Types.GET_DELIVERER_ORDERS]: getDelivererOrdersReducer,
  [Types.SET_DELIVERER_ORDERS]: setDelivererOrdersReducer,
})

export const DelivererOrderTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/delivererOrderReducer.js